<script>
import { bookingsMapper } from '@/mappers/bookings-mapper.js'

export default {
  name: 'CandidateBookings',
  props: {
    bookings: {
      type: Array,
      default: null,
    },
    timeZone: {
      type: String,
      default: null,
    },
  },
  computed: {
    mappedBookings() {
      return bookingsMapper(this.bookings, this.timeZone)
    },
  },
}
</script>

<template>
  <div class="candidate-bookings">
    <div
      v-for="yearGroup in mappedBookings"
      :key="yearGroup.year"
      class="year-group"
    >
      <p class="text-center mb-2 text-md-bold">{{ yearGroup.year }}</p>
      <div
        v-for="monthGroup in yearGroup.months"
        :key="monthGroup.month"
        class="d-flex items-center month-row"
      >
        <div class="month-label flex-shrink-0 text-md-bold">{{
          monthGroup.month
        }}</div>
        <div class="month-chart d-flex flex-grow-1">
          <div
            v-for="(day, index) in monthGroup.xseries"
            :key="index"
            class="flex-grow-1"
            :class="
              day === 'bk-booked'
                ? 'bk-booked brand-blue-400'
                : 'neutrals-grey-225'
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.year-group {
  padding: 10px;
  margin-bottom: 14px;
}

.month-row {
  margin-bottom: 10px;
}

.month-label {
  min-width: 60px;
  text-align: left;
}

.month-chart {
  height: 10px;
}

.month-chart div {
  margin: 1px;
}
</style>
